/**
 * Delay layout-heavy widgets until they are close enough to be useful.
 * Editor previews continue to initialize synchronously at their call sites.
 */
export function initializeOnApproach(element, initialize) {
  if (!element || typeof initialize !== "function") return;

  if (!("IntersectionObserver" in window)) {
    initialize();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;

      observer.disconnect();
      initialize();
    },
    { rootMargin: "500px 0px" },
  );

  observer.observe(element);
}
